module.exports={"Star Rating":"Stjerneklassifisering","# star(s)":"{currentRating, plural, =1{# stjerne} other{# stjerner}}"};